<template>
  <ve-page
    class="page--role-home-base"
    :full="true"
    direct="vertical"
    :can-back="true"
    :customeRoadMap="customeRoadMap"
  >
    <!-- <el-scrollbar 
      class="menu__wrapper"
      style="
        box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
          0 4px 25px 0 rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
      "
    >
      <custome-menu
        class="menu__out-wrapper"
        :menus="getLeftMenu"
        :routeRender="routeRender"
      ></custome-menu>
    </el-scrollbar> -->
    <div class="content" style="overflow: auto">
      <router-view :key="$route.path"></router-view>
    </div>
  </ve-page>
</template>

<script>
import { mapGetters } from "vuex";
import customeMenu from "@/components/customeMenu";

function defaultRouteRender(url) {
  return { path: url };
}

export default {
  components: {
    "custome-menu": customeMenu,
  },
  props: {
    leftMenuPackName: {
      type: String,
      default: "cat_left_menu_pack",
    },
    customeRoadMap: {
      type: Array,
      default: () => [],
    },
    routeRender: {
      type: Function,
      default: defaultRouteRender,
    },
    initHook: {
      type: Function,
      default: null,
    },
    destryHook: {
      type: Function,
      default: null,
    },
   
  },
  provide() {
    return {
      context: this.context,
    };
  },
  data() {
    return {
      context: {},
    };
  },
  computed: {
    ...mapGetters(["getLeftMenu"]),
  },
  created() {
    this.$store.dispatch("switchLeftMenu", this.leftMenuPackName);
  },
  mounted() {
    !!this.initHook && this.initHook(this);
  },
  destroyed() {
    !!this.destryHook && this.destryHook(this);
  },
};
</script>

<style lang="scss">
.page--role-home-base {
  padding: 0;
  margin: -10px;
  background-color: #F4F6F9;
  border-width: 0;
  min-height: 0;

  .menu__wrapper {
    width: 230px;
    flex-shrink: 0;
    height: 100%;

    &::before {
      content: "";
      position: absolute;
      top: 0px;
      left: 0;
      right: 0;
      height: 1px;
      // background: #3a3a3a; /*linear-gradient(#ffffff22, transparent);*/
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .el-scrollbar__thumb {
      border-radius: 1px;
    }

    .el-scrollbar__bar {
      z-index: 4;
    }

    background: #ffffff;
    background-size: cover;
    // background-image: url("../../assets/images/sidebar-2.jpg");
    background-position-x: 50%;
    background-position-y: 50%;

    &::after {
      display: block;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      // background-color: rgba(27, 27, 27, 0.85);
      top: 0;
      left: 0;
      z-index: 2;
    }
  }

  .menu__out-wrapper {
    flex-shrink: 0;
    z-index: 3;
    position: relative;
  }
  > .content {
    display: flex;
    flex: 1;
    padding: 20px 10px 10px 10px;
    flex-direction: column;
  }
}
.route-map__float {
  position: absolute;
  left: 20px;
  right: 0;
  height: 38px;
  overflow: hidden;
  // padding-left: 12px;
  margin-right: 0;
}
</style>
